import React from 'react';
import MrtDialog from './MrtDialog';

export default function MrtConfirmDialog({
  open,
  ariaLabel = '확인',
  title = '확인',
  description,
  detail,
  error,
  working = false,
  hideCancel = false,
  cancelText = '취소',
  confirmText = '확인',
  onCancel,
  onConfirm,
  zIndex,
  tone = 'danger', // danger | info
}) {
  const isDanger = tone === 'danger';
  const headStyle = isDanger
    ? { background: 'rgba(239,68,68,0.10)', borderBottom: '1px solid rgba(239,68,68,0.20)', color: 'rgba(185,28,28,0.95)' }
    : { background: 'rgba(59,130,246,0.10)', borderBottom: '1px solid rgba(59,130,246,0.18)', color: 'rgba(29,78,216,0.98)' };

  return (
    <MrtDialog
      open={open}
      ariaLabel={ariaLabel}
      onClose={onCancel}
      zIndex={zIndex}
      panelStyle={{ width: 'min(520px, 92vw)' }}
    >
      <div style={{ padding: '12px 14px', fontWeight: 950, ...(headStyle || {}) }}>
        {title}
      </div>
      <div style={{ padding: '12px 14px', display: 'grid', gap: '10px', color: 'var(--mrt-text-2)' }}>
        {description ? (
          <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--mrt-muted)' }}>
            {description}
          </div>
        ) : null}
        {detail ? (
          <div style={{ padding: '10px', borderRadius: '12px', border: '1px solid var(--mrt-border)', background: 'var(--mrt-surface-2)' }}>
            {typeof detail === 'string' ? (
              <div style={{ whiteSpace: 'pre-line', fontSize: '11px', fontWeight: 750, lineHeight: 1.35, color: 'var(--mrt-text-2)' }}>
                {detail}
              </div>
            ) : (
              detail
            )}
          </div>
        ) : null}
        {error ? (
          <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--mrt-danger)' }}>⚠️ {String(error)}</div>
        ) : null}
      </div>
      <div style={{ padding: '12px 14px', display: 'flex', justifyContent: 'flex-end', gap: '10px', borderTop: '1px solid var(--mrt-border)' }}>
        {!hideCancel ? (
          <button
            type="button"
            onClick={() => onCancel?.()}
            disabled={working}
            style={{
              height: '34px',
              padding: '0 12px',
              borderRadius: '12px',
              border: '1px solid var(--mrt-border)',
              background: 'var(--mrt-surface)',
              color: 'var(--mrt-text-2)',
              fontWeight: 900,
              cursor: 'pointer',
              opacity: working ? 0.7 : 1,
            }}
          >
            {cancelText}
          </button>
        ) : null}
        <button
          type="button"
          onClick={() => onConfirm?.()}
          disabled={working}
          style={{
            height: '34px',
            padding: '0 12px',
            borderRadius: '12px',
            border: isDanger ? '1px solid rgba(239,68,68,0.35)' : '1px solid rgba(59,130,246,0.30)',
            background: isDanger ? 'rgba(239,68,68,0.92)' : 'rgba(59,130,246,0.92)',
            color: '#fff',
            fontWeight: 950,
            cursor: 'pointer',
            opacity: working ? 0.7 : 1,
          }}
        >
          {working ? '처리 중…' : confirmText}
        </button>
      </div>
    </MrtDialog>
  );
}










